import { atom } from "recoil";

export const platformState = atom({
  key: "platform",
  default: null,
});

export const engageState = atom({
  key: "engage",
  default: null,
});

export const boardPortalState = atom({
  key: "boardPortal",
  default: null,
});

export const onboardState = atom({
  key: "onboarded",
  default: true,
});

export const fetchStatusState = atom({
  key: "fetchStatus",
  default: {
    home: false,
    actions: false,
    meetings: false,
    workflows: false,
    speakers: false,
    teams: false,
    boards: false,
    settings: false,
  },
});

export const customFieldState = atom({
  key: "customFields",
  default: [],
});

export const numberedFieldState = atom({
  key: "numberedFields",
  default: [],
});
